var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { BUSINESS_ERROR_CODES, validErrorMessageCode } from '../../../const/status-and-error-codes';
import { ConfigContext } from '../../../context';
import ErrorMessage from './ErrorMessage';
import { translate } from '../../../strings/i18n';
import getImages from '../helpers/get-images';
import ExpiredMembershipMessageBox from '../../../main-container/components/ExpiredMembershipMessageBox';
import NotEligibleMessageBox from '../../../main-container/components/NotEligibleMessageBox';
import NoEligibleMembersFound from '../../../main-container/components/NoEligibleMembersFound';
var CardHoldersErrors = function (_a) {
    var _b;
    var _c, _d;
    var _e = _a.isSamsClient, isSamsClient = _e === void 0 ? false : _e, businessErrorCode = _a.businessErrorCode;
    var config = useContext(ConfigContext).config;
    var _f = getImages({ config: config }), error = _f.error, ladyWarning = _f.ladyWarning;
    var addressChangedSubTitle = isSamsClient
        ? translate('errorMessages.addressChangedSams')
        : translate('errorMessages.addressChanged');
    var defaultError = {
        image: error,
        id: 'mch-error-message',
        title: translate('errorMessages.troubleRetrievingInformation'),
        subTitle: translate('errorMessages.tryAgainLater')
    };
    var showErrorMessageComponent = Boolean(businessErrorCode && validErrorMessageCode.includes(businessErrorCode));
    var displayBusinessErrorInitialScreen = (_b = {},
        _b[BUSINESS_ERROR_CODES.NO_ELIGIBLE_MEMBERS_FOUND] = (_jsx(NoEligibleMembersFound, {})),
        _b[BUSINESS_ERROR_CODES.EXPIRED_MEMBERSHIP] = _jsx(ExpiredMembershipMessageBox, {}),
        _b[BUSINESS_ERROR_CODES.NOT_ELIGIBLE_MEMBERS] = _jsx(NotEligibleMessageBox, {}),
        _b);
    var errorsList = [
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-primary-cardholder',
                title: translate('errorMessages.addPrimaryHolder.title'),
                subTitle: translate('errorMessages.addPrimaryHolder.subTitle'),
                extraInfo: translate('errorMessages.addPrimaryHolder.extraInfo')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.PRIMARY_CARDHOLDER
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-address-business-error',
                title: translate('errorMessages.notEligibleAccount'),
                subTitle: addressChangedSubTitle
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.ADDRESS
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-profanity',
                title: translate('errorMessages.profanity.title'),
                subTitle: translate('errorMessages.profanity.unapprovedName')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.PROFANITY
        },
        {
            errorListProps: {
                image: ladyWarning,
                id: 'mch-first-name-business-error',
                title: translate('errorMessages.notEligibleAccount'),
                subTitle: translate('errorMessages.nameChanged')
            },
            rule: businessErrorCode === BUSINESS_ERROR_CODES.FIRST_NAME
        }
    ];
    if (showErrorMessageComponent && businessErrorCode) {
        return displayBusinessErrorInitialScreen[businessErrorCode];
    }
    return (_jsx(ErrorMessage, __assign({}, ((_d = (_c = errorsList.find(function (_a) {
        var rule = _a.rule;
        return rule;
    })) === null || _c === void 0 ? void 0 : _c.errorListProps) !== null && _d !== void 0 ? _d : defaultError))));
};
export default CardHoldersErrors;
